function SsoDivider() {
    return (
        <div className="relative h-10">
            <div
                className="absolute inset-0 flex items-center"
                aria-hidden="true">
                <div className="w-full border-t border-gray-200" />
            </div>
            <div className="relative my-[10px] flex justify-center font-medium leading-6">
                <span className="bg-white px-[8px] text-base text-[var(--chakra-colors-light-text-weak)]">
                    or
                </span>
            </div>
        </div>
    );
}

export { SsoDivider };
